import Modal from 'react-bootstrap/Modal';
import { FaCheckCircle } from 'react-icons/fa';
import ActionButtonGradient from '../../../../components/button/ActionButtonGradient';

const SubmitModal = ({show, handleClose, handleOk}) => {
  return (
    <>
      <style>
        {`
          .submit-review-modal .modal-content {
            border: none;
            border-radius: 12px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.15);
          }
          .submit-review-modal .modal-header {
            border-bottom: 1px solid #e9ecef;
            padding: 1.5rem 1.5rem 1rem 1.5rem;
            background-color: #fff;
            border-radius: 12px 12px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .submit-review-modal .modal-title {
            font-weight: 600;
            color: #333;
            font-size: 1.125rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin: 0;
          }
          .submit-review-modal .modal-body {
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            font-size: 14px;
            color: #666;
            line-height: 1.5;
            text-align: center;
          }
          .submit-review-modal .modal-footer {
            border-top: 1px solid #e9ecef;
            padding: 1rem 1.5rem 1.5rem 1.5rem;
            background-color: #fff;
            border-radius: 0 0 12px 12px;
            display: flex;
            gap: 0.5rem;
            justify-content: center;
          }
          .submit-review-modal .btn {
            border-radius: 8px;
            padding: 0.5rem 1.25rem;
            font-weight: 500;
            font-size: 14px;
            transition: all 0.2s ease;
          }
          .submit-review-modal .btn-primary {
            background: linear-gradient(135deg, #02B4CC 70%, #0284C7 100%);
            border: none;
            color: white;
          }
          .submit-review-modal .btn-primary:hover {
            background: linear-gradient(135deg, #028a9e 70%, #026a8a 100%);
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(2, 180, 204, 0.3);
          }
          .submit-review-modal .btn-secondary {
            background-color: #6c757d;
            border-color: #6c757d;
            color: white;
          }
          .submit-review-modal .btn-secondary:hover {
            background-color: #5a6268;
            border-color: #545b62;
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
          }
          .submit-review-icon {
            color: #02B4CC;
            font-size: 1.125rem;
          }
        `}
      </style>
      
      <Modal 
        show={show} 
        onHide={handleClose}
        backdrop="static" 
        centered
        size="md"
        className="submit-review-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <FaCheckCircle className="submit-review-icon" />
            Submit Review
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            Are you sure you want to <strong>submit this</strong> calibration review?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <ActionButtonGradient
            onClick={handleClose}
            variant='secondary'
            children={"Cancel"}
          />
          <ActionButtonGradient
            onClick={handleOk}
            variant='primary'
            children={"Submit Review"}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SubmitModal